import { useQuery } from 'react-query'
import ManagementService from '../coreApi'
import { IRiskCategory } from '../types/feed'

const useRiskCategories = () => {
  return useQuery<IRiskCategory[], Error>('riskCategories', ManagementService.getRiskCategories)
}

export default useRiskCategories
